// Adapter: turn a recorded bundle.json (a flat map of relative path →
// UTF-8 contents) into a LoadedReceipt the verification flow accepts.
//
// The demo's receipt packages are shipped as bundle.json under
// demo-artifacts/receipts/<layer>/. Each layer id becomes a synthetic
// package directory in the virtual filesystem so multiple layers can be
// verified independently in the same page session.

import type { LoadedReceipt } from "./types.js";

export function bundleToLoadedReceipt(
  layerId: string,
  bundle: Record<string, string>
): LoadedReceipt {
  return {
    packageDirectory: `/demo/${layerId}/receipt.sequesign`,
    files: new Map(Object.entries(bundle)),
    sourceLabel: layerId
  };
}
